import { useDispatch } from 'react-redux'
import { setPostsTypeStatus } from 'store'
import { COLORS } from 'utils/styles'
import { isNotMobile } from 'utils/helpers'
import {
  CustomBtn,
  CustomMainBox
} from './styled'

export const PostTypes = ({
  editMode,
  editPostData,
  postsTypeStatus
}) => {
  const dispatch = useDispatch()

  const setTypeStatus = (typeStatus) => dispatch(setPostsTypeStatus(typeStatus))

  const animateBg = (typeStatus) => {
    if (postsTypeStatus === typeStatus) {
      return COLORS.whiteBlackGradientTopToBot2
    }

    return 'linear-gradient(180deg, rgb(255, 215, 0) 0%, rgb(255, 215, 0) 100%)'
  }

  const transitionForAll = {
    type: 'tween',
    duration: 0.8,
    background: {
      type: 'tween',
      duration: 0.3
    }
  }

  const isEditingAnArticle = (typeStatus) => {
    // if (
    //   editMode
    //   && editPostData?.id
    //   && isNotMobile()
    // ) {
    //   if (postsTypeStatus !== typeStatus) {
    //     return {
    //       width: '0%',
    //       padding: '0',
    //       height: '0px',
    //       border: 'none'
    //     }
    //   }

    //   if (postsTypeStatus === typeStatus) {
    //     return { width: '100%' }
    //   }
    // }

    // return {
    //   width: '33.33%',
    //   padding: '4px 10px',
    //   height: '40px',
    //   border: '1px black solid'
    // }
  }

  return (
    <CustomMainBox>
      <CustomBtn
        initial={false}
        animate={{
          background: animateBg('archived'),
          ...(isEditingAnArticle('archived'))
        }}
        transition={transitionForAll}
        overflow="hidden"
        pointerEvents={postsTypeStatus === 'archived' ? 'none' : 'auto'}
        onClick={() => setTypeStatus('archived')}
      >
        Archived
      </CustomBtn>

      <CustomBtn
        initial={false}
        animate={{
          background: animateBg('scheduled'),
          ...(isEditingAnArticle('scheduled'))
        }}
        transition={transitionForAll}
        overflow="hidden"
        pointerEvents={postsTypeStatus === 'scheduled' ? 'none' : 'auto'}
        onClick={() => setTypeStatus('scheduled')}
      >
        Scheduled
      </CustomBtn>

      <CustomBtn
        initial={false}
        animate={{
          background: animateBg('posted'),
          ...(isEditingAnArticle('posted'))
        }}
        transition={transitionForAll}
        overflow="hidden"
        pointerEvents={postsTypeStatus === 'posted' ? 'none' : 'auto'}
        onClick={() => setTypeStatus('posted')}
      >
        Posted
      </CustomBtn>
    </CustomMainBox>
  )
}
